import React from "react";
import { useSelector, useDispatch } from "react-redux";
import styles from "./api-result.module.css";
import { getPortal, getUser, getCart, getCurrOrder } from "../../services/selectors";
import { getCookie } from "../../utils/cookie";
import { removeFirmThunk } from "../../services/actions/firms_actions";
import { TypeConfirm, STATUSES_VALUES } from "../../utils/constants";
import { REMOVE_PRODUCT_FROM_CART, REMOVE_ACTIVE_PRODUCTS, putSyncCartThunk } from "../../services/actions/cart_actions";
import { RESET_PORTAL } from "../../services/actions/portal_actions";
import { setPrimaryKeyInProductsList } from "../../utils/util_functions";
import { patchOrderThunk, patchMakeCancelledOrderThunk } from "../../services/actions/orders_actions";
import { postSetEmailThunk } from "../../services/actions/set_email_actions";
import { postSetPasswordThunk } from "../../services/actions/set_password_actions";


const Confirm = () => {

  const { title, text, typeConfirm, firm, customer, productObj, data } = useSelector(getPortal);
  const user = useSelector(getUser);
  const cart = useSelector(getCart);
  const { order } = useSelector(getCurrOrder);
  const dispatch = useDispatch();

  const accessToken = getCookie('accessToken') || '';
  const refreshToken = getCookie('refreshToken') || '';

  const handleClick = () => {
    switch (typeConfirm) {
      case TypeConfirm.RemoveFirm:
        dispatch(removeFirmThunk(accessToken, refreshToken, firm.inn, customer.id));
        break;
      case TypeConfirm.RemoveProductFromCart:
        if (user.loggedIn && user.is_active) {
          const newProductsInCart = [
            ...cart.productsInCart.filter(productInCart => productInCart.product.id !== productObj.product.id)
          ];
          dispatch(
            putSyncCartThunk(accessToken, refreshToken,
              setPrimaryKeyInProductsList(newProductsInCart))
          );
        } else {
          dispatch({ type: REMOVE_PRODUCT_FROM_CART, payload: productObj });
        }
        dispatch({ type: RESET_PORTAL });
        break;
      case TypeConfirm.RemoveActiveFromCart:
        if (user.loggedIn && user.is_active) {
          const newProductsInCart = [
            ...cart.productsInCart.filter(productInCart => !productInCart.active)
          ]
          dispatch(
            putSyncCartThunk(accessToken, refreshToken,
              setPrimaryKeyInProductsList(newProductsInCart))
          );
        } else {
          dispatch({ type: REMOVE_ACTIVE_PRODUCTS });
        }
        dispatch({ type: RESET_PORTAL });
        break;
      case TypeConfirm.CancelOrder:
        dispatch(
          patchMakeCancelledOrderThunk(accessToken, refreshToken, order.id)
        );
        break;
      case TypeConfirm.ChangeEmail:
        if (user.loggedIn && user.is_active) {
          dispatch(
            postSetEmailThunk(
              accessToken, refreshToken, data
            )
          );
        }
        dispatch({ type: RESET_PORTAL });
        break;
      case TypeConfirm.ChangePassword:
        if (user.loggedIn && user.is_active) {
          dispatch(
            postSetPasswordThunk(
              accessToken, refreshToken, data
            )
          );
        }
        dispatch({ type: RESET_PORTAL });
        break;

      default:
        break;
    }
  }

  return (
    <>
      <h2 className={styles.title}>
        {title}
      </h2>
      <p className={styles.text}>
        {text}
      </p>
      <button
        className={`button button__red__colorReverse mb20`}
        onClick={handleClick}
      >Подтверждаю</button>
    </>
  )
}

export default Confirm;
